<template>
    <div class="payment-chart-table">
        <div
            v-show="AmortizationTableVisible"
            class="table-responsive">
            <table class="table heading-table">
                <thead>
                    <tr>
                        <th width="21%">
                            <big>Year/Mo.</big>
                        </th>
                        <th width="19%">
                            <big>Initial Balance</big>
                        </th>
                        <th width="19%">
                            <big>Principal</big>
                        </th>
                        <th width="19%">
                            <big>Interest</big>
                        </th>
                        <th width="19%">
                            <big>End Balance</big>
                        </th>
                    </tr>
                </thead>
            </table>
            <table
                v-for="(yearData, year) in amortizationBreakdown"
                :key="year"
                class="table"
                :class="{active: isActive[year]}">
                <thead>
                    <tr>
                        <th width="21%">
                            <label
                                class="table-trigger"
                                @click="toggleActive(year)">
                                <span :class="{ 'lt4-Plus': !isActive[year], 'lt4-Minus': isActive[year] }"></span> {{ year }}
                            </label>
                        </th>
                        <th width="19%">
                            <big>${{ totalPayment(year, amortizationBreakdown) }}</big>
                        </th>
                        <th width="19%">
                            <big>${{ totalPrincipal(yearData) }}</big>
                        </th>
                        <th width="19%">
                            <big>${{ totalInterest(yearData) }}</big>
                        </th>
                        <th width="19%">
                            <big>${{ totalBalance(yearData) }}</big>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr
                        v-for="(monthData, index) in yearData"
                        :key="index">
                        <td>{{ monthData.namedMonth }}</td>
                        <td>${{ currencyFilter(monthData.payment) }}</td>
                        <td>${{ currencyFilter(monthData.principal) }}</td>
                        <td>${{ currencyFilter(monthData.interestPaid) }}</td>
                        <td>${{ currencyFilter(monthData.balance) }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>
<script>
    import Accounting from 'accounting';

    export default {
        mixins: [Accounting],
        props: {
            showAmortizationTable: {
                default: true,
            },
            amortizationBreakdown: {
                default: [],
            },
            loanAmount: {
                default: 0,
            },
        },
        data() {
            return {
                isActive: {},
                AmortizationTableVisible: this.showAmortizationTable,
            };
        },
        computed: {
            AmortizationTable() {
                return this.amortizationBreakdown;
            },
        },
        mounted() {
            this.isActive[Object.keys(this.AmortizationTable)[0]] = true;
        },
        methods: {
            getLastArrayValue(data) {
                return data[data.length - 1];
            },
            totalPayment(year, amortizationBreakdown) {
                let TotalPayment;
                if (year === Object.keys(amortizationBreakdown)[0]) {
                    TotalPayment = Accounting.formatNumber(this.loanAmount, { precision: 2 });
                } else {
                    const previousYearData = year - 1;
                    const oriData = amortizationBreakdown[previousYearData];
                    const TotalPrincipal = this.getLastArrayValue(oriData);
                    TotalPayment = Accounting.formatNumber(TotalPrincipal.balance, { precision: 2 });
                }
                return TotalPayment;
            },
            totalPrincipal(yearData) {
                const TotalPrincipal = this.getLastArrayValue(yearData);
                return Accounting.formatNumber(TotalPrincipal.yearTotalPrincipal ? TotalPrincipal.yearTotalPrincipal : 0.00, { precision: 2 });
            },
            totalInterest(yearData) {
                const TotalInterest = this.getLastArrayValue(yearData);
                return Accounting.formatNumber(TotalInterest.yearTotalInterest ? TotalInterest.yearTotalInterest : 0.00, { precision: 2 });
            },
            totalBalance(yearData) {
                const TotalBalance = this.getLastArrayValue(yearData);
                return Accounting.formatNumber(TotalBalance.balance ? TotalBalance.balance : 0.00, { precision: 2 });
            },
            toggleActive(year) {
                this.isActive[year] = !this.isActive[year];
            },
            currencyFilter(figure) {
                return Accounting.formatNumber(figure, { precision: 2 });
            },
        },
    };
</script>
<style lang="scss" src="../../assets/styles/amortization-breakdown-table-new.scss"></style>
